// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__rgCpU","blueLoading":"styles_blueLoading__XGZHK","loader":"styles_loader__eJrga","rotation":"styles_rotation__ifj_V"};